import { Grid } from "@mui/material";
import { useContext, useState } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { GlobalAlertContext } from "../../../contexts/GlobalAlertContext";
import { api } from "../../../services/api";
import ButtonResend from "../../buttonResend";
import ButtonBack from "../../signin/buttonBack";
import SubTitleCard from "../../signin/cardLogin/subTitleCard";
import TitleCard from "../../signin/cardLogin/titleCard";
import InputVerification from "../../signin/inputVerification";
import ButtonSubmit from "../buttonSubmit";
import InputConfirmPassword from "../inputConfirmPassword";
import InputPassword from "../inputPassword";

export default function NewPassword({ email, handleResend, handleBack }) {
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const { signIn } = useContext(AuthContext);

  const [password, setPassword] = useState({
    error: false,
    value: "",
    errorText: "Error",
  });
  const [passwordConfirm, setPasswordConfirm] = useState({
    error: false,
    value: "",
    errorText: "Error",
  });
  const [codeConfirm, setCodeConfirm] = useState(["", "", "", "", "", ""]);
  const [validateCode, setValidateCode] = useState(false);

  const handleNewPassword = async (event) => {
    event.preventDefault();

    if (email.value === "") {
      handleToast(true, "error", "Por favor insira um email");
      return;
    }

    let codeText = "";
    codeConfirm.map((el) => {
      codeText += el;
    });

    handleLoading(true);

    try {
      const { data } = await api({
        method: "POST",
        url: "/user/recoverpassword",
        data: {
          email: email,
          password: password.value,
          confirmPassword: passwordConfirm.value,
          password_rec: codeText,
        },
      });
      handleToast(true, data.toast, data.message);
      setTimeout(async function () {
        let emailLogin = {
          value: email,
        };
        await signIn(emailLogin, password);
        handleLoading(false);
      }, "2000");
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
      handleLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (email.value === "") {
      handleToast(true, "error", "Por favor insira um email");
      return;
    }

    let codeText = "";
    codeConfirm.map((el) => {
      codeText = codeText + el;
    });

    handleLoading(true);

    try {
      const { data } = await api({
        method: "POST",
        url: "/user/validatecode",
        data: {
          email: email,
          password_rec: codeText,
        },
      });
      handleToast(true, data.toast, data.message);
      setValidateCode(true);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <ButtonBack
          onClick={
            validateCode ? () => setValidateCode(false) : () => handleBack()
          }
        ></ButtonBack>
      </Grid>
      <Grid item xs={12} sx={{ marginTop: "56px" }}>
        <TitleCard
          sx={{ fontWeight: "bold", color: "black", fontSize: "1.5rem" }}
        >
          {!validateCode ? "Redefinir Senha" : "Cadastrar nova senha"}
        </TitleCard>
      </Grid>
      {validateCode ? (
        <>
          <Grid item xs={12} sx={{ marginTop: "32px" }}>
            <InputPassword
              {...password}
              required
              onChange={({ target }) =>
                setPassword((obj) => {
                  obj.value = target.value;
                  obj.error = false;
                  return { ...obj };
                })
              }
            />
          </Grid>
          <Grid item xs={12} sx={{ marginTop: "32px" }}>
            <InputConfirmPassword
              {...passwordConfirm}
              required
              onChange={({ target }) =>
                setPasswordConfirm((obj) => {
                  obj.value = target.value;
                  obj.error = false;
                  return { ...obj };
                })
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "64px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              "& .MuiTextField-root": { m: 1, width: "%" },
            }}
          >
            <ButtonSubmit onClick={handleNewPassword}>Criar senha</ButtonSubmit>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12} sx={{ marginTop: "32px" }}>
            <SubTitleCard sx={{fontSize:"1.0rem"}}>
              Insira o código de verificação recebido pelo e-mail
            </SubTitleCard>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "32px",
              display: "flex",
              gap: "8px",
              justifyContent: "center",
            }}
          >
            {codeConfirm.map((el, i) => (
              <>
                <InputVerification
                  key={i}
                  id={"inputCode" + i}
                  value={el}
                  onChange={(item) => {
                    setCodeConfirm((arr) => {
                      if (item.target.value.length == 6) {
                        arr.map((e, index) => {
                          arr[index] = item.target.value[index];
                        });
                      } else {
                        arr[i] =
                          item.target.value[item.target.value.length - 1];
                      }
                      return [...arr];
                    });
                    let length =
                      item.target.value.length > 1
                        ? item.target.value.length - 1
                        : i + 1;
                    if (!item.target.value.length || i == 5) {
                      return;
                    }

                    const input = document.getElementById("inputCode" + length);
                    if (input) {
                      input.focus();
                    }
                  }}
                  required
                ></InputVerification>
              </>
            ))}
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "64px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              "& .MuiTextField-root": { m: 1, width: "%" },
            }}
          >
            <ButtonSubmit
              onClick={handleSubmit}
              children={"Verificar código"}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              marginTop: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              "& .MuiTextField-root": { m: 1, width: "%" },
            }}
          >
            <ButtonResend onClick={handleResend}></ButtonResend>
          </Grid>
        </>
      )}
    </Grid>
  );
}
